// @flow
import React, { Component } from "react";
import AsyncSelect from "react-select/lib/Async";
import { observer } from "mobx-react";
import { reactSelectStyles, reactSelectTheme } from "../../constants/reactSelect";

type Value = {
  value: number,
  label: string,
  apiLocationId: number | string,
};

type Props = {
  StateTitle: (string) => Promise<any>,
  onChange: ({ id: number, title: string, apiLocationId: number | string }) => void,
  id?: string,
};

class StateSelectNew extends Component<Props> {
  getOptions = (input: string, callback: (Array<Value>) => void) => {
    var stateList = [];
    this.props
      .StateTitle(input)
      .then((response) => {
        response.states.forEach((e) => {
          var optionItem = {};
          optionItem["value"] = e.node.locationId;
          optionItem["label"] = e.node.name.toString();
          optionItem["apiLocationId"] = parseInt(e.node.apiLocationId, 10) || "";
          stateList.push(optionItem);
        });
        callback(stateList);
      })
      .catch(function (error) {
        callback(error);
      });
  };
  handleChange = (value: Value, actionMeta: Object) => {
    const stateTitle = {
      id: value.value,
      title: value.label,
      apiLocationId: value.apiLocationId || "",
    };
    this.props.onChange(stateTitle);
  };
  render() {
    var stateList = [];
    this.props.store.stateList.forEach((e) => {
      var optionItem = {};
      optionItem["value"] = e.node.locationId;
      optionItem["label"] = e.node.name.toString();
      optionItem["apiLocationId"] = parseInt(e.node.apiLocationId, 10) || "";
      stateList.push(optionItem);
    });

    return (
      <AsyncSelect
        inputId={this.props.id || "statesSelect"}
        name="state"
        placeholder="State"
        noOptionsMessage={(inputValue) => "No states"}
        loadOptions={this.getOptions}
        backspaceRemoves={true}
        defaultOptions={stateList}
        onChange={this.handleChange}
        openOnFocus={true}
        styles={reactSelectStyles}
        theme={reactSelectTheme}
      />
    );
  }
}

export default observer(StateSelectNew);
